import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { element } from "prop-types";
import {
  getFocusedSection,
  setExpanded,
  setFocusedElement,
  setNewCommentCount,
  setShowDescription,
  setShowFormPopup,
  setShowTriggerTaskPopup,
  setUnreadEmailCount,
  toggleDescPopup,
} from "../../../actions/taskSidebar";
import { label, number, quote, tooltip } from "../../../config";
import { getOrderedNavbarOptionsForTaskSidebar } from "../../Tasks/tasks.constants";
import "../../Tasks/tasks.scss";
import { getRenderCondition } from "../sidebar.common";

/**
 * SidepanelQuickAction component handles jump action button logic
 * @props {}
 */
const SidepanelQuickActions = (props) => {
  const dispatch = useDispatch();
  const [focusedElementId, setFocusedElementId] = useState(null);
  const { expanded, task, isNewTask, newTaskData, focusedElement } = useSelector((state) => state.taskSidebar);
  const taskProject = isNewTask ? newTaskData?.project : task?.ProjectId;

  useEffect(() => {
    if (task?.isForm) {
      dispatch(setShowFormPopup(true));
      dispatch(toggleDescPopup({ status: false, type: "" }));
    }
  }, [task?.isForm]);

  const handleQuickActionButton = async (element) => {
    if (element.id === "task-triggered-tasks") {
      dispatch(setShowTriggerTaskPopup({ status: true, type: "triggered-tasks" }));
      dispatch(toggleDescPopup({ status: false, type: "" }));
    }
    if (element.id === "task-comments") {
      dispatch(getFocusedSection("comments"));
      dispatch(setNewCommentCount(number.ZERO));
    }
    if (element.id === "task-form") {
      dispatch(toggleDescPopup({ status: false, type: "" }));
      dispatch(setShowFormPopup(true));
    }
    dispatch(setFocusedElement(element.id));
    var elmnt = document.getElementById(element.id);
    await dispatch(setExpanded([...expanded, element.id]));
    setTimeout(() => {
      elmnt.scrollIntoView();
    }, number.SIX_HUNDRED);
  };

  const getCommentButton = (element) => {
    const { newCommentCount, commentCount } = task;
    const commentButtonDisabled = element.disableCondition();
    const titles = newCommentCount > number.ZERO ? quote.NEW_COMMENTS : commentCount > number.ZERO ? quote.VIEW_COMMENTS : quote.ADD_COMMENT;
    const commentClasses =
      newCommentCount > number.ZERO
        ? "sidebar-panel-unread-comment"
        : commentCount > number.ZERO
        ? "sidebar-panel-attachment-color"
        : "sidebar-action-buttons-color";
    return (
      <button
        title={label.PING}
        className={`cursor-pointer tooltip-text position-relative d-inline-block action-icons ${commentClasses ? commentClasses : ""} ${
          focusedElement === element.id ? "active-quick-actions" : ""
        }`}
        key={element.label}
        onClick={() => handleQuickActionButton(element)}
        disabled={commentButtonDisabled}
        onFocus={() => handleFocus(element)}
        onBlur={() => handleBlur()}
        >
        {element.icon} <span className='sidepanel-newcomment-count position-absolute'>{newCommentCount > number.ZERO && newCommentCount}</span>
      </button>
    );
  };

  const getEmailButton = (element, labelText) => {
    const { unreadEmailCount, emailCount } = task;
    const emailButtonDisabled = element.disableCondition();
    const emailClasses =
      unreadEmailCount > number.ZERO
        ? "sidebar-panel-unread-email"
        : emailCount > number.ZERO
        ? "sidebar-panel-attachment-color"
        : "sidebar-action-buttons-color";
    return (
      <button
        title={labelText}
        className={`cursor-pointer tooltip-text position-relative d-inline-block action-icons ${emailClasses ? emailClasses : ""} ${
          focusedElement === element.id ? "active-quick-actions" : ""
        }`}
        key={element.id}
        onClick={() => handleQuickActionButton(element)}
        disabled={emailButtonDisabled}
        onFocus={() => handleFocus(element)}
        onBlur={() => handleBlur()}
        >
        {element.icon} <span className='sidepanel-newcomment-count position-absolute'>{unreadEmailCount > number.ZERO && unreadEmailCount}</span>
      </button>
    );
  };

  /**
   * whether the icon color is blue or not.
   * @param {*} element
   * @returns
   */
  const getIconStyle = (element) => {
    if (element.render === "ShowAttachments") return task.attachmentCount ? "sidebar-panel-attachment-color" : "";
    if (element.render === "ShowLinkedTasks") return task.linkedTaskCount || task.subTaskCount ? "sidebar-panel-attachment-color" : "";
    return "";
  };

  const handleFocus = (element) => {
    setFocusedElementId(element.id);
  };

  const handleBlur = () => {
    setFocusedElementId(null);
  };

  return (
    <>
      <Tooltip anchorElement='target' position='left' parentTitle='true'>
        {getOrderedNavbarOptionsForTaskSidebar().map((element) => {
          const disabled = element.disableCondition();
          const label = element.label instanceof Function ? element.label() : element.label;
          const elementIcon = element.icon instanceof Function ? element.icon() : element.icon;
          const result =
            element.render &&
            getRenderCondition(element.render) &&
            (element.render === "ShowComments" ? (
              getCommentButton(element)
            ) : element.render === "ShowEmail" ? (
              getEmailButton(element, label)
            ) : (
              <button
                title={label}
                className={`cursor-pointer tooltip-text position-relative d-inline-block action-icons sidebar-action-buttons-color ${getIconStyle(
                  element
                )} ${focusedElement === element.id ? "active-quick-actions" : ""}`}
                key={element.id}
                disabled={disabled}
                onClick={() => handleQuickActionButton(element)}
                onFocus={() => handleFocus(element)}
                onBlur={() => handleBlur()}
                >
                {elementIcon}
              </button>
            ));
          return result;
        })}
      </Tooltip>
    </>
  );
};

export default SidepanelQuickActions;